<template>
  <div class="pay-systems-wrapper">
    <h4 class="modal-title">
      {{ $t('paySystemModal.heading') }}
    </h4>
    <div v-if="!loading" class="pay_systems">
      <div v-if="filteredPaymentsStatus.billline_gift_online.status" class="pay_system">
        <h6 class="subheader">Bill Line UA Hryvnas</h6>
        <input
          id="billline"
          v-model="paySystemId"
          type="radio"
          name="radio-group"
          :value="filteredPaymentsStatus.billline_gift_online.id"
          @change="paySystemClickHandler($event.target.value)"
        />
        <label for="billline">
          <span class="pay_system--block">
            <img src="../../../assets/images/mastecard-visa@compress-h37.png" alt />
          </span>
        </label>
      </div>
      <div v-if="filteredPaymentsStatus.stripe_gift_online.status" class="pay_system">
        <h6 class="subheader">Stripe</h6>
        <input
          id="stripe"
          v-model="paySystemId"
          type="radio"
          name="radio-group"
          :value="filteredPaymentsStatus.stripe_gift_online.id"
          @change="paySystemClickHandler($event.target.value)"
        />
        <label for="stripe">
          <span class="pay_system--block">
            <img src="../../../assets/images/mastecard-visa@compress-h37.png" alt />
          </span>
        </label>
      </div>
      <div v-if="filteredPaymentsStatus.billline_usd_gift_online.status" class="pay_system">
        <h6 class="subheader">Bill Line US Dollars</h6>
        <input
          id="billline_usd"
          v-model="paySystemId"
          type="radio"
          name="radio-group"
          :value="filteredPaymentsStatus.billline_usd_gift_online.id"
          @change="paySystemClickHandler($event.target.value)"
        />
        <label for="billline_usd">
          <span class="pay_system--block">
            <img src="../../../assets/images/mastecard-visa@compress-h37.png" alt />
          </span>
        </label>
      </div>
      <div v-if="filteredPaymentsStatus.multicard_gift_online.status" class="pay_system">
        <h6 class="subheader">MultiCards</h6>
        <input
          id="multicard"
          v-model="paySystemId"
          type="radio"
          name="radio-group"
          :value="filteredPaymentsStatus.multicard_gift_online.id"
          @change="paySystemClickHandler($event.target.value)"
        />
        <label for="multicard">
          <span class="pay_system--block">
            <img src="../../../assets/images/mastecard-maestro@compress-h371.png" alt />
          </span>
        </label>
      </div>
      <div v-if="filteredPaymentsStatus.epayments_gift_online.status" class="pay_system">
        <h6 class="subheader">Epayments</h6>
        <input
          id="epayments"
          v-model="paySystemId"
          type="radio"
          name="radio-group"
          :value="filteredPaymentsStatus.epayments_gift_online.id"
          @change="paySystemClickHandler($event.target.value)"
        />
        <label for="epayments">
          <span class="pay_system--block">
            <img src="../../../assets/images/mastecard-maestro@compress-h37.png" alt />
          </span>
        </label>
      </div>
      <div v-if="paymentsStatus.paymentstrust_gift_online.status" class="pay_system">
        <h6 class="subheader">Payments Trust</h6>
        <input
          id="paymentstrust"
          v-model="paySystemId"
          type="radio"
          name="radio-group"
          :value="paymentsStatus.paymentstrust_gift_online.id"
          @change="paySystemClickHandler($event.target.value)"
        />
        <label for="paymentstrust">
          <span class="pay_system--block">
            <img src="../../../assets/images/mastecard-maestro@compress-h37.png" alt />
          </span>
        </label>
      </div>
      <div v-if="filteredPaymentsStatus.ccbill_gift_online.status" class="pay_system">
        <h6 class="subheader">CCBill</h6>
        <input
          id="ccbill"
          v-model="paySystemId"
          type="radio"
          name="radio-group"
          :value="filteredPaymentsStatus.ccbill_gift_online.id"
          @change="paySystemClickHandler($event.target.value)"
        />
        <label for="ccbill">
          <span class="pay_system--block">
            <img src="../../../assets/images/mastecard-maestro@compress-h37.png" alt />
          </span>
        </label>
      </div>
      <div v-if="filteredPaymentsStatus.segpay_gift_online.status" class="pay_system">
        <h6 class="subheader">Segpay</h6>
        <input
          id="segpay"
          v-model="paySystemId"
          type="radio"
          name="radio-group"
          :value="filteredPaymentsStatus.segpay_gift_online.id"
          @change="paySystemClickHandler($event.target.value)"
        />
        <label for="segpay">
          <span class="pay_system--block">
            <img src="../../../assets/images/mastecard-maestro@compress-h37.png" alt />
          </span>
        </label>
      </div>
      <div v-if="paymentsStatus.crosspay_gift_online && paymentsStatus.crosspay_gift_online.status" class="pay_system">
        <h6 class="subheader">Bank Transfer</h6>
        <input
          id="crosspay_gift"
          v-model="paySystemId"
          type="radio"
          name="radio-group"
          :value="paymentsStatus.crosspay_gift_online.id"
          @change="paySystemClickHandler($event.target.value)"
        />
        <label for="crosspay_gift">
          <span class="pay_system--block">
            <img src="../../../assets/images/mastecard-visa@compress-h37.png" alt />
          </span>
        </label>
      </div>
      <div v-if="paymentsStatus.crosspay_ecom_gift_online && paymentsStatus.crosspay_ecom_gift_online.status" class="pay_system">
        <h6 class="subheader">Visa Mastercard</h6>
        <input
          id="crosspay_ecom_gift"
          v-model="paySystemId"
          type="radio"
          name="radio-group"
          :value="paymentsStatus.crosspay_ecom_gift_online.id"
          @change="paySystemClickHandler($event.target.value)"
        />
        <label for="crosspay_ecom_gift">
          <span class="pay_system--block">
            <img src="../../../assets/images/mastecard-visa@compress-h37.png" alt />
          </span>
        </label>
      </div>
      <div v-if="paymentsStatus.pspark_gift_online && paymentsStatus.pspark_gift_online.status" class="pay_system pay_system--full">
        <h6 class="subheader">Crypto</h6>
        <input
          id="pspark_gift"
          v-model="paySystemId"
          type="radio"
          name="radio-group"
          :value="paymentsStatus.pspark_gift_online.id"
          @change="paySystemClickHandler($event.target.value)"
        />
        <label for="pspark_gift">
          <span class="pay_system--block">
            <span class="pspark_label">Pay with crypto</span>
          </span>
        </label>
        <div v-if="parseInt(paySystemId) === paymentsStatus.pspark_gift_online.id" class="pspark_crypto_picker">
          <div v-if="psparkLoading" class="pspark_hint">…</div>
          <div v-else-if="!psparkCryptos.length" class="pspark_hint">
            No crypto wallets configured.
          </div>
          <select v-else :value="cryptoCode" class="pspark_select" @change="onCryptoChange($event.target.value)">
            <option value="" disabled>— select crypto —</option>
            <option v-for="c in psparkCryptos" :key="c.code" :value="c.code">
              {{ c.display_name }}{{ c.min_amount ? ' · min €' + c.min_amount : '' }}
            </option>
          </select>
        </div>
      </div>
      <div v-show="!anyPaySystemOnline">No pay systems online.</div>
    </div>
    <div v-else class="loader-wrap">
      <preloader />
    </div>
  </div>
</template>

<script>
import Preloader from '../parts/Preloader';

export default {
  name: 'GiftPaySystemSelect',
  components: { Preloader },
  props: {
    value: { type: Number, default: 0 },
    paymentsStatus: Object,
    loading: Boolean,
    paySystemClickHandler: Function,
    cryptoCode: { type: String, default: '' },
  },
  data: () => ({
    paySystemId: 0,
    psparkCryptos: [],
    psparkLoading: false,
  }),
  mounted() {
    if (this.paymentsStatus && this.paymentsStatus.pspark_gift_online && this.paymentsStatus.pspark_gift_online.status) {
      this.loadPsparkCryptos();
    }
  },
  watch: {
    'paymentsStatus.pspark_gift_online.status'(v) {
      if (v && !this.psparkCryptos.length) {
        this.loadPsparkCryptos();
      }
    },
  },
  computed: {
    anyPaySystemOnline() {
      return (
        this.paymentsStatus.ccbill_gift_online.status ||
        this.paymentsStatus.paymentstrust_gift_online.status ||
        this.paymentsStatus.epayments_gift_online.status ||
        this.paymentsStatus.multicard_gift_online.status ||
        this.paymentsStatus.segpay_gift_online.status ||
        this.paymentsStatus.billline_gift_online ||
        this.paymentsStatus.billline_usd_gift_online||
        this.paymentsStatus.stripe_gift_online ||
        (this.paymentsStatus.pspark_gift_online && this.paymentsStatus.pspark_gift_online.status) ||
        (this.paymentsStatus.crosspay_gift_online && this.paymentsStatus.crosspay_gift_online.status) ||
        (this.paymentsStatus.crosspay_ecom_gift_online && this.paymentsStatus.crosspay_ecom_gift_online.status)
      );
    },

    userPaymentsGroupItems() {
      return this.$store.getters.userPaymentsGroup;
    },

    filteredPaymentsStatus() {
      if (this.userPaymentsGroupItems.length > 0) {
        const filteredPaymentsStatus = Object.values(this.paymentsStatus);
        console.log(filteredPaymentsStatus,'filteredPaymentsStatus');

        filteredPaymentsStatus.forEach((paySystem) => {
          const foundActiveUserPaySystem = this.userPaymentsGroupItems.find(
            (userPaySystem) => userPaySystem === paySystem.userGroupsId
          );

          if (foundActiveUserPaySystem && paySystem.status === 1) {
            paySystem.status = 1;
          } else {
            paySystem.status = 0;
          }
        });

        return {
          ccbill_gift_online: {
            id: 1,
            status: filteredPaymentsStatus[0].status,
            userGroupsId: 4,
          },
          epayments_gift_online: {
            id: 2,
            status: filteredPaymentsStatus[1].status,
            userGroupsId: 3,
          },
          multicard_gift_online: {
            id: 3,
            status: filteredPaymentsStatus[2].status,
            userGroupsId: 1,
          },
          paymentstrust_gift_online: {
            id: 4,
            status: filteredPaymentsStatus[3].status,
            userGroupsId: 5,
          },
          segpay_gift_online: {
            id: 5,
            status: filteredPaymentsStatus[4].status,
            userGroupsId: 2,
          },
          billline_gift_online: {
            id: 6,
            status: filteredPaymentsStatus[5].status,
            userGroupsId: 6,
          },
          billline_usd_gift_online: {
            id: 7,
            status: filteredPaymentsStatus[6].status,
            userGroupsId: 6,
          },
          stripe_gift_online: {
            id: 8,
            status: filteredPaymentsStatus[7].status,
            userGroupsId: 6,
          },
          pspark_gift_online: {
            id: 10,
            status: this.paymentsStatus.pspark_gift_online ? this.paymentsStatus.pspark_gift_online.status : 0,
            userGroupsId: 10,
          },
          crosspay_gift_online: {
            id: 11,
            status: this.paymentsStatus.crosspay_gift_online ? this.paymentsStatus.crosspay_gift_online.status : 0,
            userGroupsId: 11,
          },
          crosspay_ecom_gift_online: {
            id: 12,
            status: this.paymentsStatus.crosspay_ecom_gift_online ? this.paymentsStatus.crosspay_ecom_gift_online.status : 0,
            userGroupsId: 12,
          },
        };
      }
      return {
        ccbill_gift_online: {
          id: 1,
          status: this.paymentsStatus.ccbill_gift_online.status,
          userGroupsId: 4,
        },
        epayments_gift_online: {
          id: 2,
          status: this.paymentsStatus.epayments_gift_online.status,
          userGroupsId: 3,
        },
        multicard_gift_online: {
          id: 3,
          status: this.paymentsStatus.multicard_gift_online.status,
          userGroupsId: 1,
        },
        paymentstrust_gift_online: {
          id: 4,
          status: this.paymentsStatus.paymentstrust_gift_online.status,
          userGroupsId: 5,
        },
        segpay_gift_online: {
          id: 5,
          status: this.paymentsStatus.segpay_gift_online.status,
          userGroupsId: 2,
        },
        billline_gift_online: {
          id: 6,
          status: this.paymentsStatus.billline_gift_online.status,
          userGroupsId: 6,
        },
        billline_usd_gift_online: {
          id: 7,
          status: this.paymentsStatus.billline_usd_gift_online.status,
          userGroupsId: 6,
        },
        stripe_gift_online: {
          id: 8,
          status: this.paymentsStatus.stripe_gift_online.status,
          userGroupsId: 6,
        },
        pspark_gift_online: this.paymentsStatus.pspark_gift_online || { id: 10, status: 0, userGroupsId: 10 },
        crosspay_gift_online: this.paymentsStatus.crosspay_gift_online || { id: 11, status: 0, userGroupsId: 11 },
        crosspay_ecom_gift_online: this.paymentsStatus.crosspay_ecom_gift_online || { id: 12, status: 0, userGroupsId: 12 },
      };
    },
  },
  methods: {
    async loadPsparkCryptos() {
      this.psparkLoading = true;
      try {
        const response = await this.$http.post('v1/pspark/cryptos', {
          access_token: window.localStorage['access-token'],
        });
        const body = response && response.body;
        this.psparkCryptos = body && body.status && Array.isArray(body.result) ? body.result : [];
      } catch (e) {
        this.psparkCryptos = [];
        console.error('Failed to load PsPark cryptos for gift modal', e);
      } finally {
        this.psparkLoading = false;
      }
    },
    onCryptoChange(value) {
      this.$emit('crypto-change', value);
    },
  },
};
</script>

<style scoped>
.modal-title {
  padding-bottom: 7px;
}
.subheader {
  font-size: 0.9rem;
  padding-bottom: 3px;
}
.pay_system--block img {
  width: 100%;
  height: 100%;
  cursor: pointer;
}
.pay-systems-wrapper {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  padding-bottom: 50px;
}
.pay_systems {
  display: flex;
  width: 100%;
  flex-direction: row;
  flex-wrap: wrap;
  margin-left: 20px;
}
.pay_system {
  width: 50%;
  cursor: pointer;
}
@media screen and (max-width: 425px) {
  .pay_systems {
    display: flex;
    width: 100%;
    flex-direction: row;
    flex-wrap: wrap;
    margin-left: 15px;
  }
  .pay_system {
    width: 100%;
    cursor: pointer;
  }
  .pay_system--block img {
    width: 100%;
    height: 100%;
    cursor: pointer;
  }
}
.loader-wrap {
  display: flex;
  justify-content: center;
}
.pay_system--full {
  width: 100% !important;
}
.pspark_label {
  font-size: 13px;
  font-weight: 500;
  color: #444;
}
.pspark_crypto_picker {
  margin: 8px 0 0 28px;
}
.pspark_select {
  display: block;
  width: 100%;
  max-width: 320px;
  padding: 6px 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  background: #fff;
}
.pspark_hint {
  font-size: 12px;
  color: #999;
  padding: 4px 0;
}
</style>
